import { PostBodyVehicleCorrectiveImagesType } from '@/modules/adjusterReportModules/Insurer-information/queries/postBodyVehicleCorrectiveImages/postBodyVehicleCorrectiveImages.type';
import { postBodyVehicleCorrectiveImagesFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/postBodyVehicleCorrectiveImages/postBodyVehicleCorrectiveImagesFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postBodyVehicleCorrectiveImagesOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PostBodyVehicleCorrectiveImagesType
> => ({
  mutationKey: ['postDamagedVehicleCorrectiveImagesOptions'],
  mutationFn: (params: PostBodyVehicleCorrectiveImagesType) =>
    postBodyVehicleCorrectiveImagesFunction(params),
});
